import { useState } from "react"
import classes from '../screens/game/game-styles.module.css'
import Right from "../screens/game/right";
import Wrong from "../screens/game/wrong";
let clickedOnce = false; // flag to prevent multiple clicks in less than a second
const Option = (props) => {
    const [isClicked, setIsClicked] = useState(false)
    const { currentQuestion, option, chose, isRightAnswer } = props;
    // const [optionClicked, setOptionClicked] = useState(false);
    const [isInput, setInput] = useState(option.input)
    const [inputText, setInputText] = useState('')
    function rightOrWrongHandler(valid) {
        if (valid) {
            return (
                <Right />
            )
        }
        else if (!isRightAnswer) {
            return (
                <Wrong />
            )
        }
    }
    return (
        <div className={classes.optionButton} onClick={() => {
            setIsClicked(true)
            if (!clickedOnce && !isInput) { // check for first time and make sure that option doesn't have any inputs 
                props.onClick(option)
                clickedOnce = true // stop user from clicking on the right answer when it's revealed after the user chose his answer
                setTimeout(() => {
                    clickedOnce = false // sets it again to false to enable user to choose answers again when next question appears
                }, 1000) // 1000ms is the time it takes to switch to the next question
            }
        }}>
            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                <div>
                    <h1 className={currentQuestion.type === 'compliance' ? classes.optionCompliance : classes.optionFriends}
                    > - {option.option}</h1>
                </div>
                {isInput && isClicked && // only render this input if option is clicked and it has "input" attribute in it 
                    <div className={classes.submitContainer}>
                        <input
                            className={classes.why}
                            type="text" onChange={(e) => { setInputText(e.target.value) }}
                            placeholder="why" />
                        <div className={classes.submit} type="button" onClick={() => {
                            setInput(false)
                            let temp = { ...option, why: inputText }
                            props.onClick(temp)

                        }} >Submit</div>
                    </div>}

                <div style={{ width: '50px' }}>
                    {chose && rightOrWrongHandler(option.valid)}
                </div>
            </div>
        </div>)
}
export default Option;